import { useGroupMaintenanceVM } from "presentation/hook/Group/useGroupMaintenanceVM";
import { useGroupMaintenanceTracked } from "presentation/store/Group/GroupMaintenanceProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import GroupTablePanel from "./GroupTablePanel";
const GroupMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [groupState] = useGroupMaintenanceTracked();
    const groupVM = useGroupMaintenanceVM();
    const { isBackMaster } = groupState;

    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                const results = await Promise.allSettled([
                    groupVM.onSearch(),
                    groupVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then(() => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [isBackMaster, groupVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            <SliderPanel
                isOpen={false}
                draggable={false}
                leftSectionWidth={"0%"}
                rightSectionWidth={"100%"}
                leftChildren={<GroupTablePanel />}
            />
        </div>
    </>
}
export default memo(GroupMaintenance); 
